import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 6px;
`;

export const HeaderLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  ${({ theme: { colors } }) => `color: ${colors.onSurfaceVariant};`}
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;

  ${({ theme: { spacing } }) => css`
    gap: ${spacing.level2};
  `}
`;

export const ClearAllButton = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
  font-family: inherit;

  ${({ theme: { colors } }) => css`
    color: ${colors.primary};
  `}

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
    text-decoration: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme: { colors } }) => colors.primary};
    outline-offset: 2px;
  }
`;

export const ScrollArea = styled.div`
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 240px;
  max-height: 360px;
`;

export const StatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  font-size: 13px;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurfaceVariant};
  `}
`;

export const LoadMoreSentinel = styled.div`
  height: 1px;
  width: 100%;
`;
